import { uniq } from 'lodash';
import type { AssetCategory, ProcessActivityStatus } from '@common/enums';
import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';
import type { IRecipient } from '@common/recipient';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { FormGroupRowAndColsWithFormParagraph } from '@frontend/components/fields/FormGroupRowAndColsWithFormParagraph';
import { ProcessActivityAssetsRead } from '@frontend/components/pages/episodeCategory/customControls/processActivityAssets/ProcessActivityAssetsRead';
import { SelectProcessActivityPerformerFormGroup } from '@frontend/components/pages/episodeCategory/customControls/processActivityPerformer/SelectProcessActivityPerformerFormGroup';
import type { ComponentsMap } from './readForm.types';

export function addAssetsComponent<
    ReadData extends {
        assets: ProcessActivityAsset[];
    } & Partial<Record<AssetCategory, unknown>>,
>(readSections: IProcessActivityReadSection[], map: ComponentsMap): void {
    const assetsItem = getProcessActivityReadSectionItem<ReadData>()(readSections, 'assets');
    if (!assetsItem?.value) {
        return;
    }

    const categories = assetsItem.value.map((asset) => asset.category);
    for (const category of uniq(categories)) {
        const assets = assetsItem.value.filter((asset) => asset.category === category);
        let label = assetsItem.label;
        if (category) {
            const categoryLabel = getProcessActivityReadSectionItem<ReadData>()(readSections, category)?.label;

            if (categoryLabel) {
                label = categoryLabel;
            }
        }
        if (assets.length) {
            map.set(
                category ?? assetsItem.key,
                <ProcessActivityAssetsRead
                    assets={assets}
                    label={label}
                />
            );
        }
    }
}

export function addGewichtLengteBmiComponent<ReadData extends { gewicht_lengte_bmi: string[] }>(
    readSections: IProcessActivityReadSection[],
    map: ComponentsMap
): void {
    const gewichtLengteBmiItem = getProcessActivityReadSectionItem<ReadData>()(readSections, 'gewicht_lengte_bmi');
    if (gewichtLengteBmiItem?.value) {
        map.set(
            gewichtLengteBmiItem.key,
            <FormGroupRowAndColsWithFormParagraph
                label={gewichtLengteBmiItem.label}
                values={gewichtLengteBmiItem.value}
            />
        );
    }
}

// TODO: CS-17827 make recipient mandatory
export function addRecipientComponent<ReadData extends { recipient?: IRecipient }>(
    readSections: IProcessActivityReadSection[],
    activityStatus: ProcessActivityStatus,
    map: ComponentsMap
): void {
    const recipientItem = getProcessActivityReadSectionItem<ReadData>()(readSections, 'recipient');
    if (recipientItem?.value) {
        map.set(
            recipientItem.key,
            <SelectProcessActivityPerformerFormGroup
                activityStatus={activityStatus}
                recipient={recipientItem.value}
            />
        );
    }
}

export function excludeFormComponent(map: ComponentsMap, key: string): void {
    map.set(key, <></>);
}
